import { render, staticRenderFns } from "./dashboardMain.vue?vue&type=template&id=7e2ce19c&scoped=true&"
import script from "./dashboardMain.vue?vue&type=script&lang=js&"
export * from "./dashboardMain.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e2ce19c",
  null
  
)

export default component.exports